export const synaesthetik = {
  id: "synaesthetik",
  disciplines: "Editorial, Print, Motion",
  year: 2025,
  project: "Synästhetik",
  initiatedAt: "FH Salzburg, Austria (Master)",
  shortInitiatedAt: "FHS, AT (MA)",
  thumbnailUrl: "/assets/Synaesthetik/00-S-1x1.webp",
  additionalInfo: {
    awards: [
      "Winner, Young Ones TDC New York 2025 (Book, Editorial)",
      "Gold, CCA Venus Award 2025 (Graphic, Product Design)",
      "Shortlist, CCA Venus Award 2025 (Communication Idea, Concept)",
      "Bronze, ADC*E Student Award (Publication Design)",
    ],
    exhibitions: [
      "TDC71 Exhibition New York (travel exhibition)",
      "Designmonat Graz",
    ],
    publications: [
      "The World’s Best Typography, Typography 46 Annual",
      "CCA Magazine 2025",
    ],
  },
  description:
    '"Synaesthetic" is a research-driven exploration of sequence-space synesthesia and its implications for time-based information graphics. By translating synesthetic impressions into visual form, the project challenges linear design norms and proposes dynamic, rhythm- and intuition-based representations of time that adapt to human perception.',
  credits: [
    "Initiated at MA Communication Design, FH Salzburg, Austria",
    "Mentoring Viktoria Kirjuchina, Julia Otterbach; Sound Design Tobias Türk",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/01-S-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/02-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Synaesthetik/03-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "TDC71 Exhibition New York",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/04-S-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-three-lg square-media-one-by-one",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Synaesthetik/05-9x10-Video.mp4",
          poster: "/assets/Synaesthetik/05-9x10-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-six-lg span-seven-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/06-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Synaesthetik/07-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/08-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Synaesthetik/09-S-9x10-Video.mp4",
          poster: "/assets/Synaesthetik/09-S-9x10-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/10-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Synaesthetik/11-S-9x11-Video.mp4",
          poster: "/assets/Synaesthetik/11-S-9x11-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "To experience the world through the eyes of a synesthete by deliberately moving away from typographic conventions in favor of a dynamic composition that frees the text from rigid grid structures.",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/12-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Synaesthetik/13-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "Visual hierarchies emerge through variations in type size and weight, structured not statically, but in response to content.",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/14-S-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Synaesthetik/15-S-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-six-lg span-seven-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/16-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Synaesthetik/17-S-9x10-Video.mp4",
          poster: "/assets/Synaesthetik/17-S-9x10-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "The project imagines stepping inside a synesthete’s world by observing and translating implications of their impressions into a visible form.",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Synaesthetik/18-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Synaesthetik/19-S-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Synaesthetik/20-S-16x9-Video.mp4",
          poster: "/assets/Synaesthetik/20-S-16x9-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
